export const replaceRegN = (text) => {
  let rexText
  if (text.includes('\n')) {
    rexText = text.replace(/\n/g, '</br>')
  }
  return rexText
}

export default {
  replaceRegN,
}
